import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevronright",
  "use": "icon-chevronright-usage",
  "viewBox": "0 0 24.571 64.423",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24.571 64.423\" id=\"icon-chevronright\">\n<g id=\"icon-chevronright_chevronright\">\n\t<polyline style=\"fill:none;stroke:#808080;stroke-width:10;stroke-miterlimit:10;\" points=\"4.502,2.176 19.018,32.212 \n\t\t4.502,62.247 \t\" />\n</g>\n<g id=\"icon-chevronright_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol